module.exports = __webpack_public_path__ + "static/img/3.743b652.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/3/eng/3.png
// module id = kABC
// module chunks = 0